import { defineStore } from 'pinia';

export const useAuth = defineStore('auth', () => {
  const { data: user, refresh: updateSession } = useFetch('/api/auth/user', {
    deep: true,
  });

  const isAuthenticated = computed(() => !!user.value?.id);

  const loaded = ref(false);
  async function load() {
    if (loaded.value) {
      return;
    }

    await updateSession();

    loaded.value = true;
  }

  async function login(username: string, password: string) {
    await $fetch(`/api/auth/login`, {
      method: 'POST',
      body: { username, password },
    });

    await updateSession();
  }

  async function logout() {
    await $fetch(`/api/auth/logout`, {
      method: 'POST',
    });

    await updateSession();
  }

  return {
    load,
    login,
    logout,
    isAuthenticated,
    user,
    updateSession,
  };
});
